<script>
  import {onMount, onDestroy} from 'svelte'
  import {media} from 'svelte-match-media'
  import gsap from 'gsap'
  import ScrollTrigger from 'gsap/ScrollTrigger'
  import Accordion from '../components/Accordion.svelte'
  import Chart1 from '../charts/CordCutters95M.svelte'
  import AnimatedTitle from '../components/AnimatedTitle.svelte'

  let anim = {numTo95: 0}, plugEl, cordEl, numEl, cutterEl, st

  const dashSpace = 6

  $: cutDashes = $media.mobile ? 21 : 63
  $: totalDashWidth = $media.mobile ? 250 : 720
  $: cordNum = Math.round(anim.numTo95) + 'M'
  $: dashWidth = ((totalDashWidth - dashSpace * (cutDashes - 1)) / cutDashes)
  $: staggerAmount = $media.mobile ? .06 : .02

  onMount(() => {

    const tl = gsap.timeline({onComplete: () => {
      st?.kill(false)
    }})
    tl.fromTo(cordEl, {
      scaleY: 0,
      transformOrigin: '50% 0'
    }, {
      scaleY: 1.15,
      ease: 'none',
      duration: 2
    }, 0)
    tl.to(cordEl, {
      scaleY: 1,
      ease: 'none',
      duration: .1
    }, 2.3)
    /* tl.from('.cutter-wrap', {
      clipPath: `inset(0 50%)`,
      ease: 'none',
      duration: 0.25
    }, 1.85) */
    tl.fromTo(plugEl, {
      opacity: 0,
    },{
      opacity: 1,
      duration: .3,
      ease: 'none',
    }, 2)
    tl.set(cutterEl.querySelectorAll('.dash'), {opacity: 0}, 0)
    tl.to(cutterEl.querySelectorAll('.dash'), {
      opacity: 1,
      duration: 0.15,
      stagger: staggerAmount,
      ease: 'none'
    }, 2.15)
    tl.to(cutterEl.querySelectorAll('.dash'), {
      opacity: 0,
      duration: 0.15,
      stagger: staggerAmount,
      ease: 'none'
    }, 3.3)
    tl.fromTo(plugEl, {
      y: -1,
      rotation: 0
    }, {
      duration: 3,
      y: 300,
      rotation: 30,
      ease: 'power1.inOut'
    }, 3.3)
    tl.fromTo(numEl, {
      opacity: 0,
    }, {
      opacity: 1,
      duration: 1,
      ease: 'none',
      onUpdate: () => {
        anim.numTo95 = 95 * gsap.getProperty(numEl, 'opacity')
        anim = anim
      }
    }, 4.5)
    tl.fromTo(numEl, {y: 20}, {
      duration: 2,
      y: 85,
      ease: 'power1.inOut',
    }, 4.5)
    tl.add(() => {}, 8)

    st = ScrollTrigger.create({
      trigger: '#plug-cord',
      start: () => $media.mobile ? 'top bottom-=200' : 'top center',
      end: 'bottom bottom-=200',
      scrub: 1,
      id: 'CutTheCord',
      animation: tl,
    })
  })

  onDestroy(() => {
    st?.kill()
  })

</script>
<section class="part1">
  <div class="rgrid-md-3-4">
    <div class="col">
      <AnimatedTitle size={1} class="large title1" style="maskup">It’s no secret there’s been an acceleration of cord-cutting.</AnimatedTitle>
      <AnimatedTitle size={1} delay={1} class="large title2 accent" style="maskup">By 2022, the number of cord-cutters and cord-nevers is projected to reach 95 million in the US alone.</AnimatedTitle>
    </div>
  </div>
  <div id="plug-cord" class="svg">
    <div class="num" bind:this={numEl}>{cordNum}</div>
    <svg bind:this={cordEl} id="cord" width="112" height="265" viewBox="0 0 112 265" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M60 0H52V265H60V0Z" fill="currentColor"/>
    </svg>
    <div class="cutter-wrap" bind:this={cutterEl}>
      <div class="dashes" style="width: {totalDashWidth}px">
        {#each Array.from(Array(cutDashes).keys()) as dash, i}
          <div class="dash" style={`left: ${i * (dashWidth + dashSpace)}px; width: ${dashWidth}px`}></div>
        {/each}
      </div>
    </div>
    <svg bind:this={plugEl} id="plug" width="112" height="137" viewBox="0 0 112 137" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g fill="currentColor">
        <path d="M32.2331 102.728L32.2193 136.876L40.3214 136.88L40.3352 102.731L72.7435 102.744L72.7297 136.893L80.8318 136.896L80.8456 102.747L112 102.76L112.003 94.5639L101.104 94.5599L101.111 78.1685C101.12 54.9477 83.5736 35.1344 59.9433 33.076L51.8412 33.0727C28.8845 35.1124 11.3221 54.9114 10.6375 78.1321L10.6309 94.5234L0.00329863 94.5194L0 102.715L32.2331 102.728ZM19.4148 78.1356C19.423 57.6466 35.6341 40.5788 56.5642 41.2702C76.8193 41.2784 93.0169 57.6763 93.0085 78.1652L93.0023 94.5566L19.4082 94.5269L19.4148 78.1356Z" />
        <path d="M60 0H52V34H60V0Z"/>
      </g>
    </svg>
  </div>
  <div class="rgrid-md-1-2 chart-wrap">
    <div class="col col1"><div class="title-wrap"><AnimatedTitle>US Adult Cord-Cutters <span class="nowrap">+ Cord-Nevers,</span> 2019-2022</AnimatedTitle></div></div>
    <div class="col col2">
      <Accordion title="See More" id="cord_cutters_cord_nevers" expandedOnDesktop={true}>
        <Chart1 />
      </Accordion>
    </div>
  </div>
</section>

<style>
  .part1 :global(.title1) {
    margin-bottom: -0.2em;
  }
  #plug-cord {
    padding-bottom: 300px;
    position: relative;
    margin-top: 90px;
    margin-bottom: 70px;
  }
  #plug-cord svg {
    margin: 0 auto;
  }
  .cutter-wrap {
    position: absolute;
    top: 262px;
    width: 100%;
    height: 3px;
    left: 0;
  }
  .dashes {
    position: relative;
    height: 100%;
    margin: auto;
  }
  .dash {
    background: currentColor;
    height: 100%;
    position: absolute;
  }
  #plug-cord .num {
    font-size: 144px;
    text-align: center;
    font-weight: bold;
    position: absolute;
    width: 100%;
    top: 240px;
  }
  .chart-wrap .col1 {
    display: none;
  }
  @media(min-width: 768px) {
    #plug-cord {
      margin-bottom: 140px;
    }
    #plug-cord .num {
      font-size: 248px;
      top: 354px;
    }
    .chart-wrap .col1 {
      display: block;
    }
    .chart-wrap .col1 .title-wrap {
      max-width: 490px
    }
    .chart-wrap :global(.accordion .content .title) {
      display: none;
    }
    #plug-cord svg {
      width: 180px;
      height: auto;
    }
    .cutter-wrap {
      top: 421px;
      height: 5px;
    }
  }
</style>